import { BaseColumnType } from "../../columns/config/types";
import { ReportColumnConfigBase } from "../../columns/config/ReportColumnConfig";

import {
  EstimateNumberColumn,
  ClientColumn,
  ProjectColumn,
  BudgetColumn,
  SubtotalColumn,
  OrderDateColumn,
} from "../common";

export const Columns: ReportColumnConfigBase<BaseColumnType>[] = [
  EstimateNumberColumn,
  ClientColumn,
  ProjectColumn,
  BudgetColumn,
  SubtotalColumn,
  OrderDateColumn,
];
